import { mapState } from 'vuex'
import ozFiltersDesktop from '../oz-filters-desktop'
import ozFiltersMobile from '../oz-filters-mobile'

export default {
  name: 'oz-filters-container',

  props: {
    isResultPage: { type: Boolean },
    glossary: { type: Object, required: true },
    filters: { type: Object, required: true },
    fixed: { type: Boolean },
    loading: { type: Boolean },
  },

  data () {
    return {
      isNotRefineSearch: true,
    }
  },

  watch: {
    isShowRefineSearchOnMobile () {
      this.isNotRefineSearch = !this.isShowRefineSearchOnMobile
    },
  },

  computed: {
    ...mapState({
      isShowRefineSearchOnMobile: (state) => state.results.isShowRefineSearchOnMobile,
    }),

    filtersContainerClass () {
      return {
        results__filters: true,
        'results__filters--sticky': this.isNotRefineSearch,
        'results__filters--static': !this.isNotRefineSearch,
      }
    },
  },

  methods: {
    async updateFilters (payload) {
      await this.$nextTick()

      this.$emit('filters:update', payload)
    },

    onOzFiltersUpdate (payload) {
      this.$emit('filters:update', payload)
    },

    onOzFiltersToggle (payload) {
      this.$emit('filters:toggle', payload)
    },

    onOzFiltersMap () {
      this.$emit('filters:map')
    },
  },

  components: {
    ozFiltersDesktop,
    ozFiltersMobile,
  },

}
